<script>
import { required } from 'vuelidate/lib/validators';
import ContentBlockMixin from '@shared/mixins/ContentBlock';
import ContentBlockFlashcardView from '@shared/components/ContentBlocks/Views/Flashcard.vue';
import TiptapEditor from '@shared/components/TiptapEditor.vue';

export default {
  mixins: [ContentBlockMixin],
  components: {
    ContentBlockFlashcardView,
    TiptapEditor,
  },
  static: {
    data: {
      question: '',
      question_alignment: 'center',
      answer: '',
    },
  },
  validations: {
    newData: {
      question: {
        required,
      },
      answer: {
        required,
      },
    },
  },
  i18n: {
    messages: {
      en: {
        flashcard: {
          title: 'Create a flashcard',
          labels: {
            question: 'Question (Front)',
            question_alignment: 'Alignment',
            answer: 'Answer (Back)',
          },
        },
      },
      fr: {
        flashcard: {
          title: 'Créer une carte recto-verso',
          labels: {
            question: 'Question (Recto)',
            question_alignment: 'Alignement',
            answer: 'Réponse (Verso)',
          },
        },
      },
    },
  },
};
</script>

<template>
  <ContentBlockBase>
    <template #form>
      <div>
        <h3 class="title is-5">
          {{ $t('flashcard.title') }}
        </h3>

        <b-field :label="$t('flashcard.labels.question_alignment')">
          <b-radio-button
            v-model="newData.question_alignment"
            native-value="left"
            type="is-primary"
            outlined
          >
            <b-icon class="ml-1" icon="align-left" />
          </b-radio-button>

          <b-radio-button
            v-model="newData.question_alignment"
            native-value="center"
            type="is-primary"
            outlined
          >
            <b-icon class="ml-1" icon="align-center" />
          </b-radio-button>

          <b-radio-button
            v-model="newData.question_alignment"
            native-value="right"
            type="is-primary"
            outlined
          >
            <b-icon class="ml-1" icon="align-right" />
          </b-radio-button>
        </b-field>

        <b-field
          :label-for="`question-${contentBlock.id}`"
          :label="$t('flashcard.labels.question')"
          v-bind="$getErrorProps($v.newData.question, ['required'])"
        >
          <TiptapEditor
            :value="newData.question"
            @input="newData.question = $event"
            :field-id="`question-${contentBlock.id}`"
          />
        </b-field>

        <b-field
          :label-for="`answer-${contentBlock.id}`"
          :label="$t('flashcard.labels.answer')"
          v-bind="$getErrorProps($v.newData.answer, ['required'])"
        >
          <TiptapEditor
            :value="newData.answer"
            @input="newData.answer = $event"
            :field-id="`answer-${contentBlock.id}`"
          />
        </b-field>
      </div>
    </template>
    <template #view>
      <ContentBlockFlashcardView v-bind="viewProps" :data="data" />
    </template>
  </ContentBlockBase>
</template>
